import { GraduationCap } from "lucide-react";

const DEFAULTS = { url: "", height: 36, show_name: true, mobile_url: "", mobile_height: 22, mobile_mode: "logo_name" };

export const logoConfig = (settings) => ({ ...DEFAULTS, ...(settings?.logo || {}) });

export const BrandLogo = ({ settings, mobile = false, testid = "brand-logo" }) => {
  const cfg = logoConfig(settings);
  const name = settings?.business_name || "DreamCots";
  const url = mobile ? cfg.mobile_url || cfg.url : cfg.url;
  const height = Number(mobile ? cfg.mobile_height : cfg.height) || DEFAULTS.height;
  const showName = mobile ? cfg.mobile_mode !== "logo_only" : cfg.show_name !== false;
  const showLogo = !mobile || cfg.mobile_mode !== "name_only";
  return (
    <>
      {showLogo && (url
        ? <img src={url} alt={name} data-testid={`${testid}-img`} style={{ height, width: "auto", maxWidth: mobile ? 120 : 220, objectFit: "contain" }} />
        : <span data-testid={`${testid}-fallback`} className="rounded-xl border-2 border-[#171B33] bg-[#A3E635] flex items-center justify-center shadow-[2px_2px_0_#171B33]" style={{ width: height, height }}>
            <GraduationCap className="text-[#171B33]" style={{ width: height * 0.55, height: height * 0.55 }} />
          </span>)}
      {showName && <span data-testid={`${testid}-name`} className={mobile ? "" : "font-display text-xl font-extrabold tracking-tight"}>{name}</span>}
    </>
  );
};
